<template>
  <div :class="schoolShowFlag ? 'login_popup login_popup_c' : 'login_popup'" style="background: #fff;">
    <div v-if="loginSuc" :class="schoolShowFlag ? 'login_popup login_popup_c' : 'login_popup'">
      <div class="login_success">
        <img src="../../src/images/login/success.svg" alt />
        <div class="suc_mess">登录成功</div>
        <!-- <div class="to_jump">正在跳转{{sucTo}}s</div> -->
      </div>
    </div>
    <div v-if="!loginSuc">
      <div class="back_login cursor_p" @click="backLogin()">
        <img style="width:72px;height:72px;" src="../../src/images/login/user_and_pass.png" alt />
      </div>
      <div class="qrcode_box">
        <div class="login_tit qr_tit">
          <ul class="qrcode_tit">
            <li>二维码登录</li>
          </ul>
        </div>
        <div id="login_container" style="display:flex;justify-content: center;"></div>
        <div id="qrcode" class="qr_view" ref="qrcode"></div>
        <div v-if="showMark" class="qr_mark" @click="regetCode()">
          <span>您的二维码已失效</span>
          <span>请点此处刷新按钮</span>
        </div>
        <div class="qr_mess">请使用讯飞智教学APP扫描二维码</div>
        <div class="login_btn">
          <button class="qr_btn" @click="showMarkLoginFunc(false)">下载APP</button>
        </div>
      </div>
    </div>

    <el-dialog title="下载智教学APP" :visible.sync="showMarkLogin" :close-on-click-modal="false" width="400px">
      <div class="qrcode_box" style="padding-bottom: 0;">
        <div id="login_container" style="display:flex;justify-content: center;"></div>
        <div class="qr_view">
          <img class="dlImg" src="https://www.fifedu.com/iplat/fifMobile/app_manage/download/iplat_app.png" alt="">
        </div>
        <div class="qr_mess" style="margin-bottom: 0;">手机扫描二维码下载讯飞智教学APP</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery';
import QRCode from 'qrcodejs2';
import { EduSSO } from "../../static/utils/sso";
export default {
  name:'QRView',
  data() {
    return {
      loginSuc: false,
      QrUrl: '',
      loginWithQR: '',
      showMark: false,
      timer: null,
      createData: "",
      sucTo: 3,
      showMarkLogin: false,
      isOnline: false,  // 是否为线上
      schoolShowFlag: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.codeLogin();
      // this.regetCode();
    })
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == "schoolCode") {
        this.schoolShowFlag = true;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {

  },
  methods: {
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      this.isOnline = localhostPath.indexOf('hecs.fifedu.com/iplat/');
      return localhostPath;
    },
    //获取iplat路径
    getIplatPath() {
      var curWwwPath = window.document.location.href;
      var pos = curWwwPath.indexOf('/fifLogin');
      var iplatPath = curWwwPath.substring(0, pos);
      return iplatPath;
    },
    //获取iplat路径 线上下
    getIplatCasPath() {
      // 线上
      var login = this.isOnline ? "https://cycore.fifedu.com/cas-server" : 'https://cycore.fifedu.com/cas-server';
      return login;
    },
    codeLogin() {
      var url = 'https://pass.fifedu.com/iplat-pass/web/getLoginQrCode';
      const that = this;
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        crossDomain: true,
        cache: false,
        async: false,
        success: function (res) {
          if (res.status == 1) {
            that.loginWithQR = res.data.loginWithQrPath;
            that.qrCode(res.data.codePath)  // 设置要生成二维码的链接
            that.createData = res.data.codePath;
          }
        },
        error: function (html) {
          console.log(html, 'err');
        }
      });
    },
    qrCode(url) {
      let qrcode = new QRCode('qrcode', url);
      this.judgeQR();
    },
    judgeQR() {
      var url = this.loginWithQR;
      const that = this;
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        crossDomain: true,
        cache: false,
        async: false,
        success: function (res) {
          if (res.status == 1) {
            var user = res.data.username;
            var pass = res.data.password;
            that.loginUp(user, pass)
          } else if (res.status == -1) {
            // -1 一直访问
            that.timer = setTimeout(that.judgeQR, 2 * 1000);
          } else {
            // code失效 刷新
            that.showMark = true;
          }
        },
        error: function (html) {
          console.log(html, 'err');
        }
      });
    },
    loginUp(user, pass, uuid) {
      const that = this;
      // 登录
      var loginurl = this.getIplatPath() + "/ssoservice";
      var edusso = new EduSSO(loginurl, that.getIplatCasPath());
      edusso.login(
        "iflyportal",
        "iflyportal",
        "login_name",
        user,
        pass,
        uuid,
        function (result) {
          if (result && result.result != "success") {
            that.showErr = true;
            that.errPop = result.msg;
            return;
          } else {
            // 成功跳转
            that.loginSuc = true;
            var loginSucTo = setInterval(() => {
              that.sucTo -= 1;
              if (that.sucTo == 0) {
                clearInterval(loginSucTo);
                window.location.href = that.getIplatPath() + '/ssoservice';
              }
            }, 1000);
          }
        }
      );
    },
    regetCode() {
      /* let qrcode = new QRCode('qrcode');
      qrcode.clear(); //清除二维码  */
      // qrcode.makeCode(this.createData); //生成另一个新的二维码
      $('#qrcode').html("");
      this.codeLogin();
      this.showMark = false;
    },
    backLogin() {
      this.$emit("offQRlogin", false);
    },
    showMarkLoginFunc(val) {
        this.showMarkLogin = true;
    }
  }
};
</script>

<style scoped lang="scss">
.qr_view {
  position: relative;
  height: 200px !important;
  width: 200px !important;
  border: 1px solid #e5e5e5;
  padding: 10px;
  margin: 0 auto;
}

.qr_mark {
  width: 100%;
  height: 250px;
  position: absolute;
  top: 110px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
}

.qr_mark span {
  display: block;
  width: 100%;
  font-size: 14px;
  color: #fa5b5b;
  text-align: center;
}

.qr_tit {
  padding: 60px 0 !important;
  height: auto !important;
}


/deep/ .el-dialog {
  border-radius: 8px !important;
  margin-top: 0 !important;
  top: 50%;
  transform: translate(0px, -50%);

  .el-dialog__header {
    padding: 11.5px 24px !important;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #3d444d;
    line-height: 24px;
    border-bottom: 1px solid rgba(128,128,128,0.10);
    .el-dialog__title{
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      right: 24px;
      top: 15px;
      background-image: url(../images/login/clone.svg);
      background-repeat: no-repeat;
      background-size: contain;
      height: 16px;
      width: 16px;

      .el-icon-close:before {
        content: none;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/QRView.vue